import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Loading, ContentBlock } from '@whitelabel/component-library';
import { PUBLIC_NAV_ITEMS, SOURCE_EMAIL } from '@whitelabel/xcover-shared/helpers/constants';
import { IError } from '@whitelabel/xcover-shared/helpers/types';
import ErrorPage from '../../../components/ErrorPage';
import PageMeta from '../../helpers/PageMeta';
import NavBar from '../../layout/NavBar';
import { StyledLayout } from '../../../styled/StyledLayout';
import NPSfeedbackModal from '../../../components/NPSfeedbackModal';
import { useGetPageQuery } from '../../../store/services/xcover/endpoints/pages';
import useShowCookieModal from '../../../helpers/useShowCookieModal';
import { useNPSQueryParams } from './helper';

interface IHomeProps {
  locale: string;
  slug: string;
}

export const Home = ({ locale, slug }: IHomeProps): JSX.Element => {
  const npsQueryParams = useNPSQueryParams();
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const revisionId = urlParams.get('revisionId');
  const partner = urlParams.get('partner');
  const isCookieModalOpen = useShowCookieModal();

  const { data: page, isFetching, error: fetchError } = useGetPageQuery({ slug, locale, revisionId, partner });
  const error = (fetchError as any)?.data as IError;

  if (!page && error) {
    return <ErrorPage error={error} />;
  }

  return (
    <StyledLayout navBar={<NavBar items={PUBLIC_NAV_ITEMS} size="lg" />} spacing="lg">
      {isFetching ? (
        <Loading />
      ) : (
        page && (
          <>
            <PageMeta
              title={page.title}
              seoTitle={page.meta.seoTitle}
              searchDescription={page.meta.searchDescription}
              socialTitle={page.meta.socialTitle}
              socialDescription={page.meta.socialDescription}
              socialImage={page.meta.socialImage}
              ogType={page.meta.ogType}
            />

            <ContentBlock blocks={page.body} />

            {!isCookieModalOpen && npsQueryParams && (
              <NPSfeedbackModal
                score={npsQueryParams.npsSource === SOURCE_EMAIL ? npsQueryParams.score : undefined}
                source={npsQueryParams.source}
                bookingID={npsQueryParams.bookingID}
              />
            )}
          </>
        )
      )}
    </StyledLayout>
  );
};

const mapStateToProps = (state: any) => {
  const { locale } = state.intl;
  const slug = 'home';

  return {
    locale,
    slug,
  };
};

export default connect(mapStateToProps)(Home);
